import {MetrikaProvider, Notifications, ThemeProviderv2 as ThemeProvider} from '@yandex-delivery/blocks'
import {DrawerOverlay} from '@yandex-delivery/blocks/legacy'
import {BoundCardConfigContext} from '@yandex-delivery/bound-card'
import {I18nProvider} from '@yandex-delivery/core/i18n'
import {RumObservableRoot} from '@yandex-delivery/modules/rum'
import React from 'react'
import {BrowserRouter} from 'react-router-dom'

import {Routing} from 'src/pages/desktop'
import {HandleError} from 'src/shared/components/HandleError'
import {appConfig, i18n} from 'src/shared/config'
import {BlocksVisibilityStatesProvider, UserSettingsProvider} from 'src/shared/contexts'

import AppConfigProvider from '../shared/contexts/AppConfigContext'
import * as classes from './App.classes'
import {appProps} from './consts'
import {ErrorBoundary} from './ErrorBoundary'
import {SuperwebProvider} from './SuperwebProvider'

export function App(): React.ReactElement {
  return (
    <AppConfigProvider value={appConfig}>
      <SuperwebProvider locale={appConfig.lang}>
        <MetrikaProvider yandexID={appConfig.metrikaID}>
          <ThemeProvider dir={appConfig.dir} locale={appConfig.lang}>
            <I18nProvider t={i18n}>
              <ErrorBoundary i18n={i18n}>
                <RumObservableRoot>
                  <Notifications className={classes.notifications}>
                    <BrowserRouter basename={appConfig.basename}>
                      <DrawerOverlay className={classes.drawer} zIndex={1000}>
                        <UserSettingsProvider value={appProps}>
                          <BlocksVisibilityStatesProvider>
                            <BoundCardConfigContext currency={appProps.currency} lang={appProps.lang}>
                              <Routing />
                              <HandleError />
                            </BoundCardConfigContext>
                          </BlocksVisibilityStatesProvider>
                        </UserSettingsProvider>
                      </DrawerOverlay>
                    </BrowserRouter>
                  </Notifications>
                </RumObservableRoot>
              </ErrorBoundary>
            </I18nProvider>
          </ThemeProvider>
        </MetrikaProvider>
      </SuperwebProvider>
    </AppConfigProvider>
  )
}
